<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M11.834 8a1.5 1.5 0 011.5-1.5h24a1.5 1.5 0 011.06.44l13.334 13.333a1.5 1.5 0 01.439 1.06V56a1.5 1.5 0 01-1.5 1.5H13.333a1.5 1.5 0 01-1.5-1.5V8zm3 1.5v45h34.333V22.833H37.333a1.5 1.5 0 01-1.5-1.5V9.5h-21zm24 2.121l8.211 8.212h-8.212v-8.212zM24 43.833a1.5 1.5 0 100 3h16a1.5 1.5 0 100-3H24zm-1.5-9.166a1.5 1.5 0 011.5-1.5h16a1.5 1.5 0 110 3H24a1.5 1.5 0 01-1.5-1.5zM24 22.5a1.5 1.5 0 100 3h5.334a1.5 1.5 0 000-3H24z"/></svg>